import { Building } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { MobileOptimizedCard } from '@/components/MobileOptimizedCard';
import { ResponsiveGrid } from '@/components/ResponsiveLayout';
import { useIsMobile } from '@/hooks/use-mobile';
import type { CompanySettings } from '@/lib/settingsTypes';

interface CompanySettingsTabProps {
  companySettings: CompanySettings;
  onSettingsChange: (settings: CompanySettings) => void;
  onSave: () => void;
  isSaving: boolean;
}

export const CompanySettingsTab = ({
  companySettings,
  onSettingsChange,
  onSave,
  isSaving,
}: CompanySettingsTabProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center space-x-2">
        <Building className="h-5 w-5" />
        <h2 className="mobile-subheading">Company Settings</h2>
      </div>
      
      <ResponsiveGrid cols={isMobile ? 1 : 2}>
        <MobileOptimizedCard title="Company Information">
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="company_name">Company Name</Label>
              <Input 
                id="company_name" 
                value={companySettings.company_name}
                onChange={(e) => onSettingsChange({ ...companySettings, company_name: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="address">Address</Label>
              <Textarea 
                id="address" 
                rows={3} 
                value={companySettings.address}
                onChange={(e) => onSettingsChange({ ...companySettings, address: e.target.value })}
                placeholder="Enter company address" 
              />
            </div>
            <Button 
              onClick={onSave}
              disabled={isSaving}
              className="w-full sm:w-auto"
            >
              {isSaving ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </MobileOptimizedCard>
      </ResponsiveGrid>
    </div>
  );
};
